import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router: Router = new Router({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/select-language',
      name: 'select-language',
      component: () => import('./views/SelectLanguage.vue'),
    },
    {
      path: '/select-realm',
      name: 'select-realm',
      component: () => import('./views/SelectRealm.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue'),
    },
    {
      path: '/social',
      name: 'social',
      component: () => import('./views/Social.vue'),
    },
    {
      path: '/name',
      name: 'name',
      component: () => import('./views/Name.vue'),
    },
    {
      path: '/cards',
      name: 'cards',
      component: () => import('./views/Cards.vue'),
    },
    {
      path: '/play',
      name: 'play',
      component: () => import('./views/Play.vue'),
    },
    {
      path: '/private',
      name: 'private',
      component: () => import('./views/Private.vue'),
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('./views/Shop.vue'),
    },
    {
      path: '/runes',
      name: 'runes',
      component: () => import('./views/Runes.vue'),
    },
    {
      path: '/collection',
      name: 'collection',
      component: () => import('./views/Collection.vue'),
    },
    {
      path: '/matchmaking',
      name: 'matchmaking',
      component: () => import('./views/Matchmaking.vue'),
    },
    {
      path: '/game',
      name: 'game',
      component: () => import('./views/Game.vue'),
    },
    {
      path: '/coins',
      name: 'coins',
      component: () => import('./views/Coins.vue'),
    },
    {
      path: '/eternity',
      name: 'eternity',
      component: () => import('./views/Eternity.vue'),
    },
  ],
});

export default router;
